'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = require('@pgforsta/mozart_ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search(props) {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Search.scss');
    _this.state = {
      lastSearchText: '',
      searchText: ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.doSearch = _this.doSearch.bind(_this);
    return _this;
  }

  Search.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.keyReset !== nextProps.keyReset) {
      this.setState({ lastSearchText: '', searchText: '' });
    }
  };

  Search.prototype.handleChange = function handleChange(value) {
    this.setState({ lastSearchText: this.state.searchText, searchText: value });
    if (this.props.handleChange) {
      this.props.handleChange(event.target.value);
    }
  };

  Search.prototype.handleKeyPress = function handleKeyPress(target) {
    if (target.charCode === 13) {
      target.preventDefault();
      this.doSearch();
    }
  };

  Search.prototype.doSearch = function doSearch() {
    var handleSearch = this.props.handleSearch;

    if (typeof handleSearch !== 'undefined') {
      if (this.state.searchText !== this.state.lastSearchText) {
        handleSearch(this.state.searchText);
      }
      this.setState({ lastSearchText: this.state.searchText });
    }
  };

  Search.prototype.render = function render() {
    var _props = this.props,
        placeholder = _props.placeholder,
        helpText = _props.helpText,
        label = _props.label;


    return _react2.default.createElement(
      'div',
      { style: this.props.style, className: this.styles.binary_mention_filter_search },
      _react2.default.createElement(
        _Row2.default,
        { className: 'show-grid' },
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(_mozart_ui.BinaryToolTip, {
            key: 'binary_search_tooltip',
            trigger: 'focus',
            closeAfterMillisecond: 6000,
            onExit: this.doSearch.bind(this),
            node: _react2.default.createElement(
              'div',
              { className: this.styles.binary_search },
              _react2.default.createElement(_mozart_ui.MozartTextBox, {
                value: this.state.value,
                icon: _react2.default.createElement('span', { style: { cursor: 'pointer' }, className: 'icon-Search', onClick: this.doSearch }),
                onChange: this.handleChange.bind(this),
                onKeyPress: this.handleKeyPress.bind(this),
                id: 'binary_search_box',
                type: 'text',
                validationBool: false,
                customClassName: this.styles.binary_search_input,
                style: { height: '30px !important', width: '90%', marginRight: '0px' },
                hintText: placeholder ? placeholder : 'Press Enter To Search In ' + label
              })
            ),
            data: _react2.default.createElement(
              'p',
              null,
              typeof helpText === 'undefined' ? 'Search.' : helpText
            )
          })
        )
      )
    );
  };

  return Search;
}(_react.Component), _class.propTypes = {
  style: _react.PropTypes.object,
  keyReset: _react.PropTypes.string,
  label: _react.PropTypes.string,
  placeholder: _react.PropTypes.string,
  helpText: _react.PropTypes.string,
  handleChange: _react.PropTypes.func,
  handleSearch: _react.PropTypes.func
}, _class.defaultProps = {
  label: 'List',
  helpText: 'Press Enter To Search In List'
}, _temp);
exports.default = Search;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.js
// module id = 2348
// module chunks = 0